import React from 'react';

const useForceUpdate = () => {
    const [, setValue] = React.useState<number>(Math.random);
    return () => setValue(Math.random);
};

export default useForceUpdate;
